import { gql } from '@apollo/client'

export default gql(`
    mutation deleteSeasonEpisodes($input: [ID] $assetId: ID $project: String) {
        deleteSeasonEpisodes(
            input: $input
            assetId: $assetId
            project: $project
        )
    }`
)
